import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Documentation from "./documentation/Documentation";

const App: React.FC = () => {
  return (
    <Router>
      <Documentation />
    </Router>
  );
};

export default App;
